







































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Video as IVideo } from "@/api/models/video";
import {
  currentUserIsCompanyOwner,
  getCurrentUserId,
  isRoot,
  getCurrentCompanyId
} from "@/plugins/roles";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class RecordListItemTable extends Vue {
  @Prop() video!: IVideo;

  get userId() {
    return getCurrentUserId();
  }

  get root() {
    return isRoot();
  }

  get videoOwner() {
    return this.userId === this.video.ownerId;
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get videoCompanyOwner() {
    return (
      this.companyId === this.video.companyId && currentUserIsCompanyOwner()
    );
  }

  get canEdit() {
    return this.root || this.videoOwner || this.videoCompanyOwner;
  }
}
